import React from 'react'
import { FieldProps, getIn } from 'formik'
import { MultiValue, SingleValue } from 'react-select'
import AsyncSelect from 'react-select/async'

import { reactSelectStyles, reactSelectTheme } from '../utils/reactSelect'

interface FormikAsyncSelectProps extends FieldProps {
  loadOptions: (searchTerm: string) => any[]
  getOptionLabel: (searchTerm: string) => string
  getOptionValue: (searchTerm: string) => string
  label: string
  placeholder?: string
  isMulti?: boolean
  isDisabled?: boolean
  defaultOptions?: boolean
}

const FormikAsyncSelect: React.ComponentType<FormikAsyncSelectProps> = ({ field, form, label, ...rest }) => {
  const error = getIn(form.errors, field.name)
  const isTouched = getIn(form.touched, field.name)
  const hasError = isTouched && error

  const onChange = (option: MultiValue<string> | SingleValue<string>) => {
    form.setFieldValue(field.name, option)
  }

  return (
    <div>
      <label htmlFor={field.name} className="mb-1 block text-sm font-medium text-gray-700">
        {label}
      </label>
      <AsyncSelect
        isMulti={rest.isMulti}
        isDisabled={rest.isDisabled}
        cacheOptions
        defaultOptions={rest.defaultOptions}
        noOptionsMessage={({ inputValue }) => (!inputValue ? 'Start typing..' : 'No results found!')}
        theme={reactSelectTheme}
        placeholder={rest.placeholder}
        loadOptions={rest.loadOptions}
        getOptionLabel={rest.getOptionLabel}
        getOptionValue={rest.getOptionValue}
        value={field.value}
        onChange={onChange}
        autoComplete="off"
        // @ts-ignore
        styles={reactSelectStyles}
        menuPortalTarget={document.body} //resolve z-index issue in modal
      />

      {hasError ? (
        <p className="mt-1 text-xs text-red-900" id={`${field.name}-error`}>
          {error.message}
        </p>
      ) : null}
    </div>
  )
}

export default FormikAsyncSelect
